


























import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapGetters } from "vuex";
import {
  ArrowRightIcon,
  // @ts-ignore
} from "vue-feather-icons";
import Request from "../models/checkRequest/request";
import ImportService from "@/services/importService";
import { ADD_REQUESTS } from "@/store/mutation-types";

@Component({
  components: {
    ArrowRightIcon,
  },
  computed: {
    ...mapGetters("settings", ["selectedHttpMethod", "selectedScheme"]),
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
})
export default class AddUrls extends Vue {
  dialogVisible = false;
  loading = false;
  hasActiveSubscription!: boolean;
  importService: ImportService = new ImportService();

  handleReady(result: Array<Request>) {
    if (result.length) {
      this.importService.dataToImport = result;
      this.importService.hasDataToImport = true;
      this.process();
    }
  }

  process() {
    this.$store.commit(
      `projects/${ADD_REQUESTS}`,
      this.importService.dataToImport
    );
    this.close();
  }

  close() {
    this.importService.Dispose();
    this.dialogVisible = false;
  }
}
